const license = {
    not_installed: 'هیچ مجوزی روی این نمونه نصب نشده است.',
    invalid_key: 'کلید مجوز نامعتبر است یا دستکاری شده است.',
    expired_key: 'کلید مجوز منقضی شده است. کلید تازه‌ای دریافت کنید و دوباره نصب کنید.',
};
export default Object.freeze(license);
